let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cZgLI")).then(() => parcelRequire('60RsL'));